import { createAction, props } from '@ngrx/store';
import { courseDetails, coursedetailsState, CourseStructureNode } from './course.modal';

export const setCourseAllData = createAction(
    '[Course] Set Course All Data',
    props<{ data: coursedetailsState }>()
);

export const emptyCourseAllData = createAction(
    '[Course] Empty Course All Data'
);

export const setCourseDetails = createAction(
    '[Course] Set Course Details',
    props<{ data: courseDetails }>()
);

export const setCoursePrice = createAction(
    '[Course] Set Course Price',
    props<{ data: any }>()
);

export const setCourseStructure = createAction(
    '[Course] Set Course Structure',
    props<{ data: CourseStructureNode }>()
);

export const setCourseAchievements = createAction(
    '[Course] Set Course Achievements',
    props<{ data: any }>()
);